import RestProjectController from '../../../hooks/RestProjectController'
import { useEffect } from 'react'
import Swal from 'sweetalert2'
import { SweetAlertIcon } from '../../../utils/Constants'
import { useTranslation } from 'react-i18next'
import { useUserContext } from '../../../context/UserContext'
import { useSearchParams } from 'react-router-dom'
import { userConnectionService } from '../../../services/UserConnectionService'
import { useAccessToken } from '../../../hooks/useAccessToken'


const ProjectAdminController = (model) => {
  const { t } = useTranslation()
  const token = useAccessToken();
  const { myUser } = useUserContext();

  // hooks
  const { rest } = RestProjectController();
  const [searchParams, setSearchParams] = useSearchParams();


  useEffect(() => {
    handleSearchProjects()

    // When return from google auth add account to db
    const code = searchParams.get('code');
    if (code && token) {
      // clean params
      window.history.replaceState({}, document.title, window.location.pathname);

      const handleCode = async () => {

        try {
          const params = {
            code: searchParams.get('code'),
            redirectUri: window.location.href.split('?')[0]
          }
          const data = await userConnectionService.addAccountToDatabase({ accessToken: token, params });
          if(data) {
            Swal.fire({
              title: t('Yes...'),
              icon: SweetAlertIcon.SUCCESS,
              text: t('your_account_has_been_successfully_connected')
            });
          } else {
            Swal.fire({
              title: 'Oh...',
              icon: SweetAlertIcon.INFO,
              text: t('error_occurred_connect_account')
            });
          }
        } finally {
          searchParams.delete('code');
          setSearchParams(searchParams);
          handleSearchProjects()
        }
      };

      handleCode();
    }
  }, []);



  // functions
  const handleSearchProjects = () => {

    const params = {};

    model.setIsLoading((prev) => ({ ...prev, search: true }))

    model.setIsLoading((prev) => ({ ...prev, accounts: true }));
    const userConnectedAccounts = rest({ params, endpoint: 'getUserAccountsConnected'})
      .then((data) => {
        model.setAccounts(data);
        model.setAccountsLoaded(true);
      })
      .catch((error) => {
        console.error(`Error:`, error);
      })
      .finally(() => {
        model.setIsLoading((prev) => ({ ...prev, accounts: false }))
      })

    model.setIsLoading((prev) => ({ ...prev, projects: true }));
    const userProjects = rest({ params, endpoint: 'getProjects'})
      .then((data) => {
        model.setProjects(data);
      })
      .catch((error) => {
        console.error(`Error:`, error);
      })
      .finally(() => {
        model.setIsLoading((prev) => ({ ...prev, projects: false }))
      })

  }


  const handleOnboardingAddAccountClick = () => {
    Swal.fire({
      title: t('connect_new_account'),
      text: t('you_are_going_to_be_redirected_to_google'),
      icon: SweetAlertIcon.INFO,
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: t('cancel'),
      confirmButtonText: t('go_to_google')
    }).then(async (result) => {
      if (result.isConfirmed) {
        const redirectUri = window.location.href.split('?')[0]
        const state = myUser.sub;
        window.location.href = `https://accounts.google.com/o/oauth2/auth/oauthchooseaccount?response_type=code&client_id=575090919591-7snho08ckt9qbts5apffudk57t5bp895.apps.googleusercontent.com&redirect_uri=${redirectUri}&scope=${'https://www.googleapis.com/auth/webmasters.readonly https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile'}&state=${state}&prompt=consent&access_type=offline`;
      }
    });
  }

  const handleOnboardingAddProjectClick = () => {
    model.setProjectsDialogOpened(!model.projectsDialogOpened);
  }


  return {
    handleSearchProjects,
    handleOnboardingAddAccountClick, handleOnboardingAddProjectClick
  }
}

export default ProjectAdminController